import { render, staticRenderFns } from "./OrderRatingButton.vue?vue&type=template&id=71bddb88&"
import script from "./OrderRatingButton.vue?vue&type=script&lang=js&"
export * from "./OrderRatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderRatingButton.vue"
export default component.exports